import { Avatar, Box, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import img from "../assets/prof.jpg"
const Footer = () => {
  return (
    <Box
      bgColor={"blackAlpha.900"}
      color={"whiteAlpha.700"}
      minH={"48"}
      px={"16"}
      py={["16", "8"]}
    >
      <Stack direction={["column", "row"]} h={"full"} alignItems={"center"}>
        <VStack w={"full"} alignItems={["center", "flex-start"]}>
          <Text fontWeight={"bold"}>About Us</Text>
          <Text
            fontSize={"sm"}
            letterSpacing={"widest"}
            textAlign={["center", "left"]}
          >
            Best Crypto Trading App In Pakistan, Manage to Provide or Guidance
            At Very Cheap Rate
          </Text>
        </VStack>

        <VStack>
          <Avatar boxSize={"32"} mt={["4", "0"]}  src={img} />
          <Text>Founder</Text>
          <Text>Maaz Rehman</Text>
        </VStack>
      </Stack>
    </Box>
  );
};

export default Footer;
